export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-zurb-a1190041dcb4282a4d74ef7b134fb6f6.svg";